import type { ReactNode, CSSProperties } from 'react';

export interface CardProps {
  header?: ReactNode;
  children: ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  /** Color de acento: pinta el borde de la tarjeta y la línea de la cabecera
   *  (ej. var(--evo-amber) para tarjetas de advertencia del diseño). */
  accent?: string;
  style?: CSSProperties;
}

const BODY_PAD = {
  none: '0',
  sm:   '10px 16px',
  md:   '16px 20px',
  lg:   '20px 24px',
} satisfies Record<string, string>;

export function Card({ header, children, padding = 'sm', accent, style }: CardProps) {
  return (
    <div style={{
      border: `1px solid ${accent ?? 'var(--evo-stroke)'}`,
      borderRadius: 'var(--evo-r-md)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      ...style,
    }}>
      {header !== undefined && (
        <div style={{
          padding: 'var(--evo-card-head-pad)',
          background: 'var(--evo-bg-2)',
          borderBottom: `1px solid ${accent ?? 'var(--evo-stroke)'}`,
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--evo-card-head-gap)',
        }}>
          {header}
        </div>
      )}
      <div style={{ padding: BODY_PAD[padding], flex: 1 }}>
        {children}
      </div>
    </div>
  );
}

export function CardTitle({ children }: { children: ReactNode }) {
  return (
    <span style={{
      fontSize: 'var(--evo-fs-caption)',
      fontWeight: 'var(--evo-fw-medium)',
      fontFamily: 'var(--evo-font)',
      letterSpacing: 'var(--evo-ls-caps)',
      textTransform: 'uppercase' as const,
      color: 'var(--evo-fg-3)',
      margin: 0,
    }}>
      {children}
    </span>
  );
}
